import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useDynamicFavicon = () => {
  const location = useLocation();

  useEffect(() => {
    const favicon = document.getElementById('favicon');
    if (!favicon) return;

    const path = location.pathname;

    if (path === '/dash' || 
        path === '/dashapp' || 
        path === '/dashtags' ||
        path === '/dashradio' || 
        path === '/dashplaylist' || 
        path === '/dasheventos') {
      favicon.href = '/assets/icons/dash-icon.png';
    } else if (path === '/radio') {
      favicon.href = '/assets/icons/radio-icon.png';
    } else {
      favicon.href = '/assets/icons/logo64.png';
    }
  }, [location.pathname]);
};

export default useDynamicFavicon;
